import React from 'react';

const logos = [
  {
    name: 'Kaiser Permanente',
    site: 'https://healthy.kaiserpermanente.org/',
    img: '/images/logos/kaiser-7e4ffa2a.png',
  },
  {
    name: 'University of Kansas Hospital',
    site: 'https://www.kansashealthsystem.com/',
    img: '/images/logos/kansas-bde6b540.png',
  },
  {
    name: 'Rutgers Dental',
    site: 'https://sdm.rutgers.edu/',
    img: '/images/logos/rutgers-9ad8b033.png',
  },
  {
    name: 'University of Michigan Health',
    site: 'https://www.uofmhealth.org/',
    img: '/images/logos/umich-ba45b599.png',
  },
  {
    name: 'OHSU',
    site: 'https://www.ohsu.edu/',
    img: '/images/logos/ohsu-43eee7dd.png',
  },
  {
    name: 'Endeavor Health',
    site: 'https://www.endeavorhealth.org',
    img: '/images/logos/endeavor-6025451a.png',
  },
  {
    name: 'Hartford HealthCare',
    site: 'https://hartfordhealthcare.org',
    img: '/images/logos/hartford-ec32c536.png',
  },
  {
    name: 'Nebraska Medicine',
    site: 'https://www.nebraskamed.com',
    img: '/images/logos/nebraska-c56a568e.png',
  },
  {
    name: "Arkansas Children's",
    site: 'https://www.archildrens.org',
    img: '/images/logos/arkansas-e483338c.png',
  },
];

const track = [...logos, ...logos];

const PartnersLogos: React.FC = () => (
  <section className="logo-banner-section">
    <p className="logo-banner-heading">Trusted by Healthcare Systems Nationwide</p>
    <div className="logo-banner-mask">
      <div className="logo-banner-track">
        {track.map((l, i) => (
          <a
            key={i}
            href={l.site}
            target="_blank"
            rel="noopener noreferrer"
            className="logo-banner-item"
            aria-label={l.name}
          >
            <picture>
              <source srcSet={l.img.replace(/\.[^.]+$/, '.avif')} type="image/avif" />
              <img src={l.img} alt={l.name} className="logo-banner-img" />
            </picture>
          </a>
        ))}
      </div>
    </div>
  </section>
);

export default PartnersLogos;
